import store from '@/store'

export default {
    $http : null,
    getPermPaths(next) {
        if(store.perm.paths){
            next();
        }else{
            this.$http.get(store.ctx + "/msu/admin/perm/paths").then((response) =>{
                store.perm.paths = response.data;
                next();
            });
        }
    },
    vueDirective: {
        bind: function (el, binding, vnode) {   
          var perm = binding.value;
          var flag = false;
          if(store.perm.paths)
            store.perm.paths.forEach(function(path){  
              if(path == perm)
                flag = true;
            });      
          if(flag == false)
            el.parentNode.removeChild(el);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/perm/index.js